import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { InsightsAsset } from "graphql-types/graphql";
import {
    BuildingDataView,
    MaterialsLifespanView,
} from "legacyNext/pages/Asset/views";

import { S } from "../../asset-overview.styles";

type Props = {
    asset: InsightsAsset;
};

export const BuildingDataTab = (props: Props) => {
    const { asset } = props;
    const { t } = useTranslation();

    return (
        <S.Tab>
            <S.Section>
                <Typography variant="h2">
                    {t("legacyNext.buildingData", "building data")}
                </Typography>
                <BuildingDataView asset={asset} />
            </S.Section>
            <S.Section>
                <Typography variant="h2">
                    {t(
                        "legacyNext.MaterialsAndLifespan",
                        "Materials and lifespan"
                    )}
                </Typography>
                <MaterialsLifespanView assetExternalId={asset.externalId} />
            </S.Section>
        </S.Tab>
    );
};
